<template>
	<div class="template text" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<input class="input_value" @blur.prevent="changeCount(dataVal.Property.Title[0].Text)" v-model="dataVal.Value"
			@click="click()"
			@blur="blur()"
			 :readOnly="dataVal.Disable|| dataVal.Property.Title[0].Text=='签约时间'||dataVal.Property.Title[0].Text=='代码'||dataVal.Property.Title[0].Text=='晋升职位'||dataVal.Property.Title[0].Text=='原职位'||dataVal.Property.Title[0].Text=='部门'||dataVal.Property.Title[0].Text=='职位'||dataVal.Property.Title[0].Text=='人员'||dataVal.Property.Title[0].Text=='工号'||dataVal.Property.Title[0].Text=='入职时间'||dataVal.Property.Title[0].Text=='联系电话'||dataVal.Property.Title[0].Text=='申请时间'||dataVal.Property.Title[0].Text=='端口费用承担部门'"
			 :placeholder="dataVal.Property.Placeholder[0].Text==''?'请输入':dataVal.Property.Placeholder[0].Text " />
			 <ul class="dept-list" v-show="showlist" >
			 	<li @click='clickOption(item)' v-for="(item,index) in dataVal.Option" :key='index' :class="dataVal.Value == item?'select':''">{{item}}</li>
			 </ul>
		</div>
	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui'
	export default {
		props: ['dataVal'],
		data() {
			return {
				showlist:false
			}
		},
		mounted() {
			if(this.$route.name == '/salaryManager' && this.dataVal.Property.Title[0].Text == '部门 '){
				this.showlist = false;
			}
		},
		methods: {
			changeCount(val) {
				if (val.indexOf("公司电话") == -1 && (/^.{0,}电话$/.test(val)) && this.dataVal.Value != null) {
					if (!(/^1[3456789]\d{9}$/.test(this.dataVal.Value) || /^\d{3,4}-\d{7,8}$/.test(this.dataVal.Value))) {
						Message({
							message: "电话号码有误，请重填(座机格式如下:区号（3或4位）+电话号码（7或8位），如 028-86766488)",
							type: 'error',
							duration: 3 * 1000
						});
						this.dataVal.Value = null;
						return;
					}
				}
				this.$emit('child-event', this.dataVal.Value, val);
			},
			click(){
				if(this.$route.name == '/salaryManager' && this.dataVal.Property.Title[0].Text == '部门 '){
					this.showlist = true;
				}
			},
			blur(){
				var that = this;
				if(this.$route.name == '/salaryManager' && this.dataVal.Property.Title[0].Text == '部门 '){
					 setTimeout(function(){that.showlist = false;},200);
					
				}
			},
			clickOption(val){
				this.dataVal.Value = val;
				this.$emit('child-event', val, 'Option');
			}
		}
	}
</script>

<style>
	@import '../assets/css/common.css';

	.input_value {
		width: calc(100% - 124px);
	}
	.dept-list{
		position: absolute;
		right: 0;
		top: 35px;
		z-index: 900;
		width: calc(100% - 124px);
		padding: 5px 0;
		margin: 5px 0;
		max-height: 200px;
		overflow: auto;
		background-color: #fff;
		box-sizing: border-box;
		border-radius: 4px;
		box-shadow: 0 1px 6px rgba(0,0,0,.2);
	}
	.dept-list li{
		margin: 0;
		line-height: normal;
		padding: 7px 16px;
		color: #515a6e;
		font-size: 14px!important;
		white-space: nowrap;
		list-style: none;
		cursor: pointer;
	}
	.dept-list li:hover{
		background-color: #f3f3f3;
	}
	.dept-list li.select{
		background-color: #f3f3f3;
		color: #2d8cf0
	}
</style>
